import React from 'react';
import './StepIndicator.css';

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div>
      <ol className="step-indicator">
        {steps.map((step, index) => {
          let status = 'todo';
          if (index < currentStep) status = 'done';
          else if (index === currentStep) status = 'active';

          return (
            <li
              key={step.name}
              className={`step-indicator__item step-indicator__item--${status}`}
            >
              <div className="step-indicator__node">
                <span className="step-indicator__dot">
                  {status === 'done' ? '✓' : index + 1}
                </span>
                <span className="step-indicator__label">{step.name}</span>
              </div>
            </li>
          );
        })}
      </ol>
      <div className="step-indicator__current">
        Step {currentStep + 1} of {steps.length}: <strong>{steps[currentStep]?.name}</strong>
      </div>
    </div>
  );
};

export default StepIndicator;
